export default __webpack_public_path__ + "static/media/goodreads-navbar.fc002442.png";